import React from "react";
import Field from "src/components/common/FormComponents/Field";
import { CommentFiledProps } from "src/components/Feedback/components/types";

const FieldComment: React.FC<CommentFiledProps> = ({ register }) => {
  return (
    <Field
      register={register("comment")}
      rows={4}
      placeholder="Ваше сообщение"
      multiline
    />
  );
};

export default FieldComment;
